import React, { Component } from "react";
import { Divider } from "antd";
import onClickOutside from "react-onclickoutside";
import { CSSTransitionGroup } from "react-transition-group";
import notificationDenied from "../../Assets/Images/notification_denied.png";

class InstructionsNotifications extends Component {
  handleClickOutside = () => {
    this.props.close();
  };
  render() {
    const { permissionDenied } = this.props;
    return (
      <CSSTransitionGroup
        transitionName="tooltip-animation"
        transitionEnterTimeout={400}
        transitionLeaveTimeout={100}
      >
        {permissionDenied ? (
          <div className="popover arrow-bottom">
            <div style={{ padding: "1rem", textAlign: "center" }}>
              Desbloquear notificaciones
            </div>
            <Divider style={{ margin: 0 }} />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                padding: "1rem",
                fontFamily: "Montserrat",
                fontWeight: 400
              }}
            >
              Siga estas instrucciones para desbloquear las notificaciones.
              <a
                href="https://s3.amazonaws.com/as-public-images/notification_denied.png"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={notificationDenied}
                  alt="Instructiosn enable notifications"
                  style={{ height: "120px", borderRadius: "10px" }}
                />
              </a>
            </div>
          </div>
        ) : null}
      </CSSTransitionGroup>
    );
  }
}
export default onClickOutside(InstructionsNotifications);



// WEBPACK FOOTER //
// ./src/Components/Comments/InstructionsNotifications.js